import React, { useEffect, useState } from "react";
import { Routes, Route, useParams, Link } from "react-router-dom";
import { IoPeople, IoInformationCircle, IoCard, IoPencil, IoNewspaper, IoDesktop, IoPawOutline } from "react-icons/io5";

import Loader from "../../../components/loader";

import api from "../../../services/api";

import Info from "./info";
import EditorBis from "./editorbis";
import Compta from "./compta";
import Logs from "./logs";
import Bank from "./bank";
import Collection from "./collection";
import Raw from "../../../components/Raw";
import toast from "react-hot-toast";

const TABS = [
  { title: "Info", href: "", icon: <IoInformationCircle /> },
  { title: "Compta", href: "compta", icon: <IoDesktop /> },
  { title: "Editor", href: "editorbis", icon: <IoPencil /> },
  { title: "Logs", href: "logs", icon: <IoNewspaper /> },
  { title: "Banks", href: "bank", icon: <IoPeople /> }, // oupsie
  { title: "Collection", href: "collection", icon: <IoPawOutline /> },
  { title: "Raw", href: "raw", icon: <IoNewspaper /> },
];

const Invoice = () => {
  const [invoice, setInvoice] = useState(null);
  const [project, setProject] = useState();
  const { id } = useParams();

  const fetchInvoiceData = async (invoiceId) => {
    try {
      const { ok: okInvoice, data: invoiceObject } = await api.get(`/invoice/${invoiceId}?getLeadCashout=true`);
      if (!okInvoice) throw Error("Impossible de récupérer la facture");
      setInvoice(invoiceObject);

      const { ok: okProject, data: projectData } = await api.get(`/project/${invoiceObject.projectId}`);
      if (!okProject) throw Error("Impossible de récupérer le projet");
      setProject(projectData);
    } catch (e) {
      console.log("a", e);
      toast.error(e.message || "Une erreur est survenue lors du chargement de la facture");
    }
  };

  useEffect(() => {
    fetchInvoiceData(id);
  }, [id]);

  if (!invoice || !project) return <Loader />;

  return (
    <div className="px-8 py-12 flex flex-col gap-4">
      <div className="flex justify-between">
        <div className="flex items-center justify-between gap-2 w-full">
          <h1 className="text-3xl text-gray-900">
            Invoice - {invoice.name} {invoice.index ? `#${invoice.index}` : ""}
          </h1>
          <Link to={`/project/${invoice.projectId}`} className="empty-btn">
            See the project
          </Link>
        </div>
      </div>

      <TabBar tabs={TABS} />

      <div className="w-full">
        <Routes>
          <Route path="/" element={<Info invoice={invoice} setInvoice={setInvoice} project={project} setProject={setProject} />} />
          <Route path="/compta" element={<Compta invoice={invoice} setInvoice={setInvoice} project={project} setProject={setProject} />} />
          <Route path="/editorbis" element={<EditorBis invoice={invoice} setInvoice={setInvoice} project={project} />} />
          <Route path="/logs" element={<Logs invoice={invoice} setInvoice={setInvoice} project={project} setProject={setProject} />} />
          <Route path="/bank" element={<Bank invoice={invoice} setInvoice={setInvoice} project={project} setProject={setProject} />} />
          <Route path="/collection" element={<Collection invoice={invoice} setInvoice={setInvoice} project={project} setProject={setProject} />} />
          <Route path="/raw" element={<Raw data={invoice} />} />
        </Routes>
      </div>
    </div>
  );
};

const TabBar = ({ tabs }) => (
  <div className="overflow-x-scroll">
    <nav className="bg-white rounded-md flex item-center gap-1 w-full border border-neutral-300 p-1">
      {tabs.map((tab, i) => (
        <TabItem key={i} href={tab.href} title={tab.title} icon={tab.icon} />
      ))}
    </nav>
  </div>
);

const TabItem = ({ href, title, icon }) => {
  const { id } = useParams();
  const active = href === "" ? window.location.pathname === `/project/${id}` : window.location.pathname === `/project/${id}/${href}`;

  return (
    <Link to={`/invoice/${id}/${href}`} className={`${active ? "blue-btn" : "transparent-btn"} relative rounded py-2 px-4 flex items-center gap-2`}>
      {icon}
      <div className="flex items-center gap-2 truncate">{title}</div>
    </Link>
  );
};

export default Invoice;
